/*
 * @Author: xiehangyi
 * @LastEditors: xiehangyi
 * @Description: 文件相关接口
 */
import { request } from '@/apis/request';

// 文件上传
export function fileUpload(data, url) {
  return request({
    url: url || '/v1/app/file/operate/upload',
    method: 'post',
    data
  })
}

// 文件下载
export function fileDownload(url) {
  return request({
    url,
    method: 'get',
    responseType: 'blob'
  })
}